<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"> </p>
<p class="center"><img alt="" src="OEBPS/images/9780812589085_tp.png"/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780812589085_L01.png"/><br/><span class="small">A TOM DOHERTY ASSOCIATES BOOK<br/>NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780812589085_epub_tp_r1.vue?34b6a98e